import { ODSFooter, ODSFooterMenuItem } from '@telekom-ods/react-ui-kit';
import { useNavigate } from 'react-router';

const Footer = () => {
  const navigate = useNavigate();

  const renderNavItem = (to: string, label: string) => (
    <ODSFooterMenuItem
      text={label}
      onClick={() => {
        navigate(to);
      }}
    />
  );

  return (
    <ODSFooter
      copyrightText='© DT Europe Holding GmbH'
      variant='minimal'
    >
      {renderNavItem('/contact-us', 'Contact')}
      {renderNavItem('/gtc', 'Terms and conditions')}
      {renderNavItem('/about-us', 'Imprint')}
      {renderNavItem('/data-privacy', 'Data Privacy')}
    </ODSFooter>
  );
};

export default Footer;
